import { Group, Paper, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconChartLine, IconChartBar, IconWorld } from "@tabler/icons-react";
import { getStaticSectorSuccessStories } from "../sectorEcosystem.const";
import SectorDashboardCard from "./SectorDashboardCard";

const TILES = [
  {
    key: "introductions" as const,
    label: "Successful Introductions",
    icon: IconChartLine,
    bg: "#DCFCE7",
    color: "#166534",
  },
  {
    key: "businessMeetings" as const,
    label: "Business Meetings",
    icon: IconChartBar,
    bg: "#DBEAFE",
    color: "#1D4ED8",
  },
  {
    key: "crossBorderConnections" as const,
    label: "Cross Border Connections",
    icon: IconWorld,
    bg: "#EDE9FE",
    color: "#6D28D9",
  },
];

type SectorSuccessStoriesCardProps = {
  slug: string;
};

export default function SectorSuccessStoriesCard({ slug }: SectorSuccessStoriesCardProps) {
  const successStories = getStaticSectorSuccessStories(slug);

  return (
    <SectorDashboardCard
      title="Success Stories"
      subtitle="Proof of outcomes."
    >
      <Stack gap="xs">
        {TILES.map((tile) => {
          const Icon = tile.icon;
          const value = successStories[tile.key];
          return (
            <Paper
              key={tile.key}
              p="sm"
              radius="md"
              style={{ backgroundColor: tile.bg, border: "none" }}
            >
              <Group justify="space-between" wrap="nowrap">
                <Group gap="xs" wrap="nowrap">
                  <ThemeIcon size={28} radius="md" style={{ backgroundColor: "#fff", color: tile.color }}>
                    <Icon size={14} />
                  </ThemeIcon>
                  <Text size="sm" fw={600} c={tile.color}>
                    {value}+ {tile.label}
                  </Text>
                </Group>
              </Group>
            </Paper>
          );
        })}
      </Stack>
    </SectorDashboardCard>
  );
}
